'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _blacklist = require('blacklist');

var _blacklist2 = _interopRequireDefault(_blacklist);

var Button = require('./Button');
var Spinner = require('./Spinner');

var FileUpload = (function (_React$Component) {
    _inherits(FileUpload, _React$Component);

    function FileUpload(props) {
        _classCallCheck(this, FileUpload);

        _get(Object.getPrototypeOf(FileUpload.prototype), 'constructor', this).call(this, props);
        this.displayName = 'FileUpload';
        this.state = {
            file: {},
            loading: false
        };
    }

    _createClass(FileUpload, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.fileInput.addEventListener('click', function () {
                this.value = '';
            }, false);
        }
    }, {
        key: 'triggerFileBrowser',
        value: function triggerFileBrowser() {
            this.refs.fileInput.click();
        }
    }, {
        key: 'handleChange',
        value: function handleChange(e) {
            var self = this;
            var reader = new FileReader();
            var file = e.target.files[0];

            reader.readAsDataURL(file);

            reader.onloadstart = function () {
                self.setState({
                    loading: true
                });
            };
            reader.onloadend = function (upload) {
                self.setState({
                    loading: false,
                    file: file,
                    dataURI: upload.target.result
                }, function () {
                    self.props.onChange ? self.props.onChange(self.state.file) : null;
                });
            };
        }
    }, {
        key: 'cancelUpload',
        value: function cancelUpload() {
            this.setState({
                dataURI: false,
                file: {}
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state;
            var dataURI = _state.dataURI;
            var file = _state.file;

            // props
            var props = (0, _blacklist2['default'])(this.props, 'buttonClassChange', 'buttonClassInitial', 'buttonLabelChange', 'buttonLabelInitial', 'disabled', 'file', 'onChange');

            // elements
            var component = _react2['default'].createElement(
                Button,
                {
                    onClick: this.triggerFileBrowser.bind(this),
                    disabled: this.props.disabled || this.state.loading
                },
                this.state.loading && _react2['default'].createElement(Spinner, null),
                this.props.buttonLabelInitial
            );

            if (dataURI) {
                component = _react2['default'].createElement(
                    'div',
                    { className: 'FileUpload' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'FileUpload__image' },
                        _react2['default'].createElement('img', { className: 'FileUpload__image-src', src: dataURI })
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'FileUpload__content' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'FileUpload__message' },
                            file.name,
                            ' (',
                            Math.round(file.size / 1024),
                            'Kb)'
                        ),
                        _react2['default'].createElement(
                            'div',
                            { className: 'FileUpload__buttons' },
                            _react2['default'].createElement(
                                Button,
                                { onClick: this.triggerFileBrowser.bind(this), disabled: this.state.loading },
                                this.state.loading && _react2['default'].createElement(Spinner, null),
                                this.props.buttonLabelChange
                            ),
                            _react2['default'].createElement(
                                Button,
                                {
                                    onClick: this.cancelUpload.bind(this),
                                    type: 'link-cancel',
                                    disabled: this.state.loading
                                },
                                'Cancel'
                            )
                        )
                    )
                );
            }

            return _react2['default'].createElement(
                'div',
                null,
                component,
                _react2['default'].createElement('input', _extends({
                    style: { display: 'none' },
                    type: 'file',
                    ref: 'fileInput',
                    onChange: this.handleChange.bind(this)
                }, props))
            );
        }
    }]);

    return FileUpload;
})(_react2['default'].Component);

FileUpload.propTypes = {
    buttonLabelChange: _propTypes2['default'].string,
    buttonLabelInitial: _propTypes2['default'].string,
    disabled: _propTypes2['default'].bool,
    file: _propTypes2['default'].object, // https://developer.mozilla.org/en/docs/Using_files_from_web_applications
    onChange: _propTypes2['default'].func
};

FileUpload.defaultProps = {
    buttonLabelInitial: 'Upload File',
    buttonLabelChange: 'Change File',
    disabled: false
};

module.exports = FileUpload;


//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/kepler/lib/components/FileUpload.js
// module id = 963
// module chunks = 0 1